module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExAutocomplete,
      "code": _vm.ExAutocompleteCode,
      "title": "Autocomplete",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                To have autocomplete functionality, add the "), _c('code', [_vm._v("autocomplete")]), _vm._v(" prop.\n                You can add any prop from "), _c('router-link', {
    attrs: {
      "to": "/documentation/autocomplete"
    }
  }, [_vm._v("Autocomplete")]), _vm._v(" API.\n            ")], 1)]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTemplatedAutocomplete,
      "code": _vm.ExTemplatedAutocompleteCode,
      "title": "Templated Autocomplete",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                Slots are available for autocomplete items and the empty message, like with the "), _c('router-link', {
    attrs: {
      "to": "/documentation/autocomplete"
    }
  }, [_vm._v("Autocomplete")]), _vm._v(" control.\n            ")], 1)]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExLimit,
      "code": _vm.ExLimitCode,
      "title": "Limits",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                You can limit the length and number of tags with the "), _c('code', [_vm._v("maxlength")]), _vm._v(" and "), _c('code', [_vm._v("maxtags")]), _vm._v(" props.\n                Maxlength counter is only shown when typing.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExState,
      "code": _vm.ExStateCode,
      "title": "States",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can change the input type setting a "), _c('code', [_vm._v("type")]), _vm._v(" on "), _c('b', [_vm._v("Field")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExType,
      "code": _vm.ExTypeCode,
      "title": "Tag types",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSize,
      "code": _vm.ExSizeCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExModifier,
      "code": _vm.ExModifierCode,
      "title": "Modifiers",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can change the style of the tags by setting the "), _c('code', [_vm._v("rounded")]), _vm._v(" and "), _c('code', [_vm._v("attached")]), _vm._v(" props.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExValidation,
      "code": _vm.ExValidationCode,
      "title": "Validation",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can validate the value before adding it to the tag list")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c8bded"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/taginput/Taginput.vue
// module id = 1557
// module chunks = 7